module.exports = __webpack_public_path__ + "img/North Tower.1760bc3a.png";